module.exports = __webpack_public_path__ + "img/3Collars,Harnesses.007b78af.jpg";